import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import {
  NgIconComponent,
  NgIconConfigToken,
  provideIcons,
} from '@ng-icons/core';
import { ICON_MAP, IconName } from '../types';
import { ICON_PROVIDERS } from './ui-icon-registry';

@Component({
  selector: 'stx-ui-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIconComponent],
  viewProviders: [provideIcons(ICON_MAP), ...ICON_PROVIDERS],
  host: {
    '[class]': '`${variant()}`',
  },
  styles: `
    :host {
      display: inline-flex;
      align-self: center;
      justify-self: center;
    }

    :host.filled {
      padding: 0.75rem;
      border-radius: 0.75rem;
    }

    :host.outline {
      border: 1px solid var(--mat-sys-primary);
      padding: 0.75rem;
      border-radius: 0.75rem;
    }
  `,
  template: ` <ng-icon
    [name]="name()"
    [size]="size()"
  />`,
})
export class UiIconComponent {
  readonly variant = input<'normal' | 'filled' | 'outline'>('normal');
  defaultSize = inject(NgIconConfigToken).size;
  readonly name = input.required<IconName>();
  readonly size = input<string>(this.defaultSize ?? '24');
}
